import { Tooltip } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import Shipment from '../../../../types/api/shipment'
import AvailabilityIcon from '../components/cells/availability-icon'
import {
    getFormsAvailabilityStatus,
    getMaterialAvailabilityStatus,
    getStampAvailabilityStatus,
} from '../helpers/get-availability-status'

export function createAvailabilityColumns<T>(
    getShipment: (record: T) => Shipment | undefined
): ColumnsType<T>[number] {
    return {
        title: 'Наличие',
        children: [
            {
                title: <Tooltip title={'Штамп'}>Ш</Tooltip>,
                width: 26,
                align: 'center',
                render: (_, record) => (
                    <AvailabilityIcon
                        display={getStampAvailabilityStatus(getShipment(record)?.stamp)}
                    />
                ),
            },
            {
                title: <Tooltip title={'Формы'}>Ф</Tooltip>,
                width: 26,
                align: 'center',
                render: (_, record) => (
                    <AvailabilityIcon
                        display={getFormsAvailabilityStatus(getShipment(record)?.form_set)}
                    />
                ),
            },
            {
                title: <Tooltip title={'Материал'}>М</Tooltip>,
                width: 26,
                align: 'center',
                render: (v, record) => (
                    <AvailabilityIcon
                        display={getMaterialAvailabilityStatus(getShipment(record))}
                    />
                ),
            },
        ],
    }
}
